import { Injectable } from '@angular/core';
import { OpenIdConfiguration } from './open-id-configuration';


@Injectable({
  providedIn: 'root'
})
export class OpenIdConfigurationService {

  configuration: OpenIdConfiguration;

  constructor() { }

  loadConfiguration(configuration) {
    this.configuration = configuration;
  }
}
